import MainLayout from "../layouts/MainLayout";
import PublicLayout from "../layouts/PublicLayout";
import EventRegistrationFormLayout from "../layouts/EventRegistrationFormLayout.js";
import AdminLayout from "../layouts/AdminLayout";
import Dashboard from "../pages/Member/Dashboard/dashboard.js";
import Profile from "../pages/Member/Profile/profile.js";
import EditProfile from "../pages/Member/Profile/edit_profile.js";
import MembersList from "../pages/Member/Profile/members_list.js";
import ChangePassword from "../pages/Member/Profile/change_password.js";
import Notification from "../pages/Member/Notification/notification.js";
import Login from "../pages/login/login";
import RetrieveEmail from "../pages/login/retrieve_email.js";
import MembershipSelection from "../pages/login/membership_selection.js";
import PasswordAuthentication from "../pages/login/password_authentication.js";
import SetNewPasswordAndPin from "../pages/login/set_new_password.js";
import ResetPin from "../pages/Member/Profile/reset_pin.js";
import ForgotPassword from "../pages/login/forgot_password.js";
import MyEvent from "../pages/Member/MyEvent/my_event.js";
import DiscoverEvent from "../pages/Member/DiscoverEvent/discover_event.js";
import EventDetails from "../pages/Member/DiscoverEvent/event_details.js";
import ViewEvent from "../pages/Member/MyEvent/view_event.js";
import EventPayment from "../pages/Member/DiscoverEvent/event_payment.js";
import Gallery from "../pages/Member/Gallery/gallery.js";
import Acknowledgement from "../pages/Member/DiscoverEvent/acknowledgement.js";
import GalleryDetails from "../pages/Member/Gallery/gallery_details.js";
import EventGallery from "../pages/Member/Gallery/event_gallery.js";
import Document from "../pages/Member/Document/document.js";
import DocumentDetails from "../pages/Member/Document/document_details.js";
import MembershipRenewal from "../pages/Member/Profile/membership_renewal.js";
import SetNewPassword from "../pages/login/set_new_password.js";
import OTP from "../pages/login/otp.js";
import FirstTimeOTP from "../pages/login/first_time_otp.js";
import FirstTimeLogin from "../pages/login/first_time_login.js";
import Welcome from "../pages/login/welcome.js";

import SecAccount from "../pages/Member/SecondaryAccount/secondary_account.js";
import CorporateRegister from "../pages/MembershipRegistration/corporate_register.js";
import IndividualRegister from "../pages/MembershipRegistration/individual_register.js";

import AdminLogin from "../pages/AdminLogin/login.jsx";
import AdminForgotPassword from "../pages/AdminLogin/forgotPassword.jsx";
import AdminSendOTP from "../pages/AdminLogin/adminResetOTP.jsx";
import AdminLoginResetPassword from "../pages/AdminLogin/adminResetPassword.jsx";
import AdminDashboard from "../pages/Admin/dashboard.tsx";
import AdminResources from "../pages/Admin/create_resources.jsx";
import AdminResourcesTable from "../pages/Admin/resources.tsx";
import AdminUploadPhoto from "../pages/Admin/upload_photo.jsx";
import AdminPhotoGallery from "../pages/Admin/photo_gallery.tsx";
import AdminResourcesCategories from "../pages/Admin/resources_categories.tsx";
import AdminRegResourcesCategories from "../pages/Admin/create_resources_categories.jsx";
import AdminCreateBroadcasts from "../pages/Admin/create_broadcast.jsx";
import AdminBroadcastsTable from "../pages/Admin/broadcasts.tsx";
import AdminMembershipInvoice from "../pages/Admin/membership_invoices.tsx";
import AdminMembershipInvoiceInfo from "../pages/Admin/membership_invoice_info.jsx";
import AdminCreateSignature from "../pages/Admin/create_signature.jsx";
import AdminEventInvoice from "../pages/Admin/event_invoice.tsx";
import AdminInvoiceNotes from "../pages/Admin/invoice_notes.tsx";
import AdminMemberFeeNotes from "../pages/Admin/member_fee_notes.tsx";
import AdminCreateInvoiceNotes from "../pages/Admin/create_invoice_notes.jsx";
import AdminCorporateInfo from "../pages/Admin/corporate_info.jsx";
import AdminIndividualInfo from "../pages/Admin/individual_info.jsx";
import AdminAddCorporateMember from "../pages/Admin/add_corporate_member.jsx";
import AdminMemberUserInfo from "../pages/Admin/member_user_info.jsx";
import AdminEventInfo from "../pages/Admin/event_info.jsx";
import EventGuestJoinLink from "../pages/EventRegistration/event_guest_link.jsx";
import AdminEventBlast from "../pages/Admin/event_blast.jsx";
import AdminEventBlast2 from "../pages/Admin/event_blast_2.jsx";
import AdminBlastDraft from '../pages/Admin/blast_draft.tsx';
import AdminBlastHistory from "../pages/Admin/blast_history.tsx";
import AdminBlastHistoryInfo from "../pages/Admin/blast_history_info.tsx";
import AdminEvent from "../pages/Admin/event.tsx";
import AdminEventCategories from "../pages/Admin/event_categories.tsx";
import AdminCorporateMembership from "../pages/Admin/corporate_membership_applications.tsx";
import AdminAffiliateCorporateMembership from "../pages/Admin/affiliate_corporate_membership_applications.tsx";
import AdminAffiliateIndividualMembership from "../pages/Admin/affiliate_individual_membership_applications.tsx";
import AdminIndividualMembership from "../pages/Admin/individual_membership_applications.tsx";
import AdminAssociateMembership from "../pages/Admin/associate_membership_applications.tsx";
import AdminHonoraryMembership from "../pages/Admin/honorary_membership_applications.tsx";
import AdminRegEvent from "../pages/Admin/create_event";
import AdminRegEventCategories from "../pages/Admin/create_event_categories.jsx";
import AdminResetPassword from "../pages/Admin/reset_password.jsx";
import AdminCorporateForm from "../pages/Admin/corporate_form.jsx";
import AdminIndividualForm from "../pages/Admin/individual_form.jsx";
import AdminSecretariatList from "../pages/Admin/secretariat.tsx";
import AdminSignaturesTable from "../pages/Admin/signatures.tsx";
import AdminCMSAuditsTable from "../pages/Admin/cms_audits.tsx";
import AdminMobileAuditsTable from "../pages/Admin/mobile_audits.tsx";
import AdminWebAuditsTable from "../pages/Admin/web_audits.tsx";

//added by delon - 2025-03-26
import MallGallery from '../pages/Admin/mall_gallery.tsx';
import AdminEventGallery from '../pages/Admin/admin_event_gallery.tsx';
import AdminNoticeBoard from '../pages/Admin/admin_notice_board.tsx';

// Export the routes array instead of using JSX
const Themeroutes = [
  {
    path: "/corporate_membership_application",
    element: <PublicLayout />,
    children: [
      {
        path: "/corporate_membership_application",
        element: <CorporateRegister />,
      },
    ],
  },
  {
    path: "/individual_membership_application",
    element: <PublicLayout />,
    children: [
      {
        path: "/individual_membership_application",
        element: <IndividualRegister />,
      },
    ],
  },
  {
    path: "/admin/login",
    children: [
      {
        path: "/admin/login",
        element: <AdminLogin />,
      },
    ],
  },
  {
    path: "/admin",
    children: [
      {
        path: "/admin/forgotPassword",
        element: <AdminForgotPassword />,
      },
      {
        path: "/admin/admin_reset_otp",
        element: <AdminSendOTP />,
      },
      {
        path: "/admin/admin_reset_password",
        element: <AdminLoginResetPassword />,
      },
    ],
  },
  {
    path: "/join_event",
    element: <EventRegistrationFormLayout />,
    children: [
      {
        path: "/join_event",
        element: <EventGuestJoinLink />,
      },
    ],
  },
  {
    path: "/admin",
    element: <AdminLayout />,
    children: [
      { path: "/admin/dashboard", element: <AdminDashboard /> },
      { path: "/admin/create_resources", element: <AdminResources /> },
      { path: "/admin/resources", element: <AdminResourcesTable /> },
      { path: "/admin/upload_photo", element: <AdminUploadPhoto /> },
      { path: "/admin/photo_gallery", element: <AdminPhotoGallery /> },
      {
        path: "/admin/resources_categories",
        element: <AdminResourcesCategories />,
      },
      {
        path: "/admin/create_resources_categories",
        element: <AdminRegResourcesCategories />,
      },
      {
        path: "/admin/membership_invoice",
        element: <AdminMembershipInvoice />,
      },
      {
        path: "/admin/membership_invoice_info",
        element: <AdminMembershipInvoiceInfo />,
      },
      {
        path: "/admin/corporate_info",
        element: <AdminCorporateInfo />,
      },
      {
        path: "/admin/individual_info",
        element: <AdminIndividualInfo />,
      },
      {
        path: "/admin/add_corporate_member",
        element: <AdminAddCorporateMember />,
      },
      {
        path: "/admin/member_user_info",
        element: <AdminMemberUserInfo />,
      },
      {
        path: "/admin/event_info",
        element: <AdminEventInfo />,
      },
      {
        path: "/admin/event_blast/*",
        element: <AdminEventBlast />,
      },
      // {
      //   path: "/admin/event_blast/*",
      //   element: <AdminEventBlast2 />,
      // },
      {
        path: "/admin/blast_draft/*",
        element: <AdminBlastDraft />,
      },
      {
        path: "/admin/blast_history",
        element: <AdminBlastHistory />,
      },
      {
        path: "/admin/blast_history_info",
        element: <AdminBlastHistoryInfo />,
      },
      {
        path: "/admin/event_invoice",
        element: <AdminEventInvoice />,
      },
      {
        path: "/admin/invoice_notes",
        element: <AdminInvoiceNotes />,
      },
      {
        path: "/admin/member_fee_notes",
        element: <AdminMemberFeeNotes />,
      },
      {
        path: "/admin/create_invoice_notes",
        element: <AdminCreateInvoiceNotes />,
      },
      { path: "/admin/event_categories", element: <AdminEventCategories /> },
      {
        path: "/admin/corporate_membership_applications",
        element: <AdminCorporateMembership />,
      },
      {
        path: "/admin/individual_membership_applications",
        element: <AdminIndividualMembership />,
      },
      {
        path: "/admin/affiliate_corporate_membership_applications",
        element: <AdminAffiliateCorporateMembership />,
      },
      {
        path: "/admin/affiliate_individual_membership_applications",
        element: <AdminAffiliateIndividualMembership />,
      },
      {
        path: "/admin/associate_membership_applications",
        element: <AdminAssociateMembership />,
      },
      {
        path: "/admin/honorary_membership_applications",
        element: <AdminHonoraryMembership />,
      },
      { path: "/admin/create_event", element: <AdminRegEvent /> },
      {
        path: "/admin/create_event_categories",
        element: <AdminRegEventCategories />,
      },
      {
        path: "/admin/reset_password",
        element: <AdminResetPassword />,
      },
      {
        path: "/admin/corporate_form",
        element: <AdminCorporateForm />,
      },
      {
        path: "/admin/individual_form",
        element: <AdminIndividualForm />,
      },
      {
        path: "/admin/create_signature_info",
        element: <AdminCreateSignature />,
      },
      {
        path: "/admin/broadcasts",
        element: <AdminBroadcastsTable />,
      },
      {
        path: "/admin/create_broadcast",
        element: <AdminCreateBroadcasts />,
      },
      {
        path: "/admin/secretariat_list",
        element: <AdminSecretariatList />,
      },
      {
        path: "/admin/signatures",
        element: <AdminSignaturesTable />,
      },
      {
        path: "/admin/cms_audits",
        element: <AdminCMSAuditsTable />,
      },
      {
        path: "/admin/mobile_audits",
        element: <AdminMobileAuditsTable />,
      },
      {
        path: "/admin/web_audits",
        element: <AdminWebAuditsTable />,
      },
      //added by delon - 2025-03-26
      {
        path: "/admin/mall_gallery",
        element: <MallGallery/>
      },
      {
        path: "/admin/admin_event_gallery",
        element: <AdminEventGallery/>
      },
      {
        path: "/admin/admin_notice_board",
        element: <AdminNoticeBoard/>
      }
    ],
  },
  {
    path: "/admin",
    element: <AdminLayout />,
    children: [{ path: "/admin/event", element: <AdminEvent /> }],
  },
  {
    path: "/",
    element: <MainLayout />, // FullLayout is your main layout
    children: [
      { path: "/welcome", element: <Welcome /> }, // This will render Welcome at "/welcome"
      { path: "/login", element: <Login /> }, // This will render Login at "/login"
      { path: "/first_time_login", element: <FirstTimeLogin /> }, // This will render First Time Login at "/first_time_login"
      { path: "/otp", element: <OTP /> }, // This will render OTP at "/otp"
      { path: "/first_time_otp", element: <FirstTimeOTP /> }, // This will render OTP at "/otp"
      { path: "/forgot_password", element: <ForgotPassword /> }, // This will render ForgotPassword at "/forgot_password"
      { path: "/retrieve_email", element: <RetrieveEmail /> }, // This will render RetrieveEmail at "/retrieve_email"
      { path: "/membership_selection", element: <MembershipSelection /> }, // This will render MembershipSelection at "/membership_selection"
      { path: "/password_authentication", element: <PasswordAuthentication /> }, // This will render MembershipSelection at "/password_authentication"
      { path: "/set_new_password", element: <SetNewPasswordAndPin /> }, // This will render MembershipSelection at "/set_new_password"
      { path: "/dashboard", element: <Dashboard /> }, // This will render Dashboard at "/dashboard"
      { path: "/profile", element: <Profile /> }, // This will render Profile at "/profile"
      { path: "/edit_profile", element: <EditProfile /> }, // This will render EditProfile at "/edit_profile"
      { path: "/change_password", element: <ChangePassword /> }, // This will render change password page at "/change_password"
      { path: "/reset_pin", element: <ResetPin /> }, // This will render change password page at "/change_password"
      { path: "/membership_renewal", element: <MembershipRenewal /> }, // This will render membership renewal page at "/membership_renewal"
      { path: "/notification", element: <Notification /> }, // This will render Notification at "/notification"
      { path: "/secondary_account", element: <SecAccount /> }, // This will render Notification at "/secondary_account"
      { path: "/my_event", element: <MyEvent /> }, // This will render Notification at "/my_event"
      { path: "/view_event/:eventId", element: <ViewEvent /> }, // This will render Notification at "/view_event"
      { path: "/discover_event", element: <DiscoverEvent /> }, // This will render Notification at "/discover_event"
      { path: "/event_details/:eventId", element: <EventDetails /> }, // This will render Notification at "/event_details"
      { path: "/event_payment/:eventId", element: <EventPayment /> }, // This will render Notification at "/event_details"
      { path: "/gallery", element: <Gallery /> }, // This will render Notification at "/gallery"
      {
        path: "/acknowledgement/:eventRegistrationID",
        element: <Acknowledgement />,
      }, // This will render Acknowledgement at "/acknowledgement"
      { path: "/gallery_details", element: <GalleryDetails /> }, // This will render Gallery Details at "/gallery_details"
      { path: "/document", element: <Document /> }, // This will render Notification at "/document"
      { path: "/event_gallery", element: <EventGallery /> }, // This will render Event Gallery at "/event_gallery"
      { path: "/document_details", element: <DocumentDetails /> }, // This will render document_details at "/document_details"
      { path: "/members_list", element: <MembersList /> }, // This will render Notification at "/members_list"
    ],
  },
];

export default Themeroutes;
